/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum PrestatieanalyseVSOUitzondering {
    TELT_MEE_VOOR_PRESTATIEANALYSE = "Telt mee voor prestatieanalyse",
    MINDER_DAN_6_WEKEN_INGESCHREVEN = "Minder dan 6 weken ingeschreven"
}
